const $ = require('jquery')
const Vue = require('vue')

Vue.directive('force-select', {
    priority: 1000,

    params: ['vtitle', 'position'],

    bind: function () {
        $(this.el).on('click', function () {
            if (window.getSelection && document.createRange) {
                const selection = window.getSelection()
                const range = document.createRange()
                range.selectNodeContents(this)
                selection.removeAllRanges()
                selection.addRange(range)
            } else if (document.selection && document.body.createTextRange) {
                const range = document.body.createTextRange()
                range.moveToElementText(this)
                range.select()
            }
        })
    }
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/force-select.js